<template>
  <button
    class="btn-close warning-modal-btn p-0"
    type="button"
    data-bs-dismiss="modal"
    aria-label="Close"
    style="
      opacity: 0;
      width: 0;
      height: 0;
      background: transparent;
      pointer-events: none;
    "
  >
    X
  </button>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div
        class="modal-body d-flex flex-column align-items-center justify-content-center"
      >
        <img src="../../../assets/images/icon/warning.png" />
        <h2>
          WARNING!<br />
          Are you sure?
        </h2>
      </div>
      <div
        class="modal-footer d-flex flex-column align-items-center justify-content-center"
      >
        <p class="text-center" v-if="note"><span>Note</span> {{ note }}</p>
        <button
          class="btn btn-outline-warning"
          type="button"
          @click="onConfirm"
        >
          Yes
        </button>
        <button class="btn btn-primary" type="button" @click="onCancel">
          No
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["onSave", "note"],
  methods: {
    onCancel() {
      const btn = document.querySelector(".warning-modal-btn");
      btn.click();
    },
    onConfirm() {
      // console.log("you click confirm")
      this.$emit("on-save");
      // this.onCancel();
      // this.onSave && this.onSave();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  max-width: 425px;
}
.modal-content {
  border: none;
  border-radius: 81px 8px 8px 8px;
}
.modal-body {
  border: none;
  width: 425px;
  height: 276.33px;
  flex-shrink: 0;
  padding: 20px 60px;
  border-radius: 81px 8px 81px 0px;
  background: linear-gradient(180deg, #ffae2c 0%, #ffd188 100%);
  h2 {
    margin: 13px 0 0;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 100% */
  }
  img {
    width: 140px;
    height: 140px;
  }
  h1 {
    color: #ffbc10;
    text-align: center;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  p {
    color: #fff;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
  }
}
.modal-footer {
  height: 271px;
  width: 425px;
  border: none;
  padding: 20px 0 30px;
  flex-wrap: nowrap;
  border-radius: 8px;
  background: #fff;
  p {
    width: 317.705px;
    height: 73.339px;
    flex-shrink: 0;
    color: #a9a9a9;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    span {
      color: #ffae2c;
      text-align: center;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      display: block;
      line-height: 18px; /* 112.5% */
    }
  }
  button.btn-primary {
    display: flex;
    width: 352px;
    height: 61px;
    padding: 11px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 8px;
    border-color: #ffae2c !important;
    background-color: #ffae2c !important;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 112.5% */
    &:hover {
      border-color: #ffca2c !important;
      background-color: #ffca2c !important;
    }
  }
  button.btn-outline-warning {
    display: flex;
    width: 352px;
    height: 61px;
    padding: 11px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #ffae2c;
    color: #ffae2c;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 112.5% */
    &:hover {
      color: white;
      background-color: #ffae2c !important;
      border-color: #ffae2c !important;
    }
  }
}
.btn-close {
  color: #fff;
  font-family: Inter;
  font-size: 50px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  position: fixed;
  top: 31px;
  right: 40px;
  opacity: 1;
  &:hover {
    color: #fff;
  }
}
</style>